import TopicResult from './TopicResult'

export default TopicResult
